export const alarm_atn = {value: 'alarm_atn', name: '绝对值'};
export const alarm_top = {value: 'alarm_top', name: '超过上限告警'};
export const alarm_down = {value: 'alarm_down', name: '超过下限告警'};
export const alarm_convergence = {value: 'alarm_convergence', name: '告警收敛'};
export const recover = {value: 'recover', name: "告警恢复"};
export const gateway_online = {value: 'gateway_online', name: "主机在线"};
export const gateway_offline = {value: 'gateway_offline', name: "主机离线"};
export const device_online = {value: 'device_online', name: "设备在线"};
export const device_offline = {value: 'device_offline', name: "设备离线"};

export function getType(name) {
  switch (name) {
    case alarm_atn.value:
      return alarm_atn.name
    case alarm_top.value:
      return alarm_top.name;
    case alarm_down.value:
      return alarm_down.name;
    case recover.value:
      return recover.name;
    case gateway_online.value:
      return gateway_online.name;
    case gateway_offline.value:
      return gateway_offline.name;
    case device_online.value:
      return device_online.name;
    case device_offline.value:
      return device_offline.name;
    case alarm_convergence.value:
      return alarm_convergence.name;
    default:
      return name;
  }
}
